import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { mergeProps } from '@react-aria/utils';
import { buttonReset } from "../Button/Button";
import { useSharedHoverContext } from "../SharedHover/SharedHoverContext";
import { Text } from "../Text";
import { useForkedRef } from "../../hooks";
import React, { useRef } from 'react';
import styled from 'styled-components';
import { theme, whenActive, whenFocused } from "../../theme";
import { rectToObject } from "../../utils/rect-to-object";
export var NavItem = React.forwardRef(function (_ref, forwardedRef) {
  var href = _ref.href,
      as = _ref.as,
      label = _ref.label,
      iconBefore = _ref.iconBefore,
      iconAfter = _ref.iconAfter,
      isSelected = _ref.isSelected,
      disabled = _ref.disabled,
      other = _objectWithoutProperties(_ref, ["href", "as", "label", "iconBefore", "iconAfter", "isSelected", "disabled"]); // Ensure all refs are forwarded to the button to support
  // things like tooltips and popovers.


  var ownRef = useRef(null);
  var ref = useForkedRef(forwardedRef, ownRef);

  var _useSharedHoverContex = useSharedHoverContext(),
      onEnterTarget = _useSharedHoverContex.onEnterTarget,
      onLeaveTarget = _useSharedHoverContex.onLeaveTarget,
      enabled = _useSharedHoverContex.enabled;

  if (!enabled) {
    throw new Error('NavItem must be used within NavGroup');
  }

  var defaultAs = href !== undefined ? 'a' : 'button';

  function onMouseEnter(e) {
    if (isSelected) {
      return;
    }

    var bounds = rectToObject(e.currentTarget.getBoundingClientRect());
    onEnterTarget(_objectSpread(_objectSpread({}, bounds), {}, {
      top: bounds.top + 2,
      bottom: bounds.bottom - 2,
      height: bounds.height - 4
    }));
  }

  function hideHover() {
    onLeaveTarget();
  }

  return /*#__PURE__*/React.createElement(StyledNavItem, _extends({
    $isSelected: isSelected,
    as: as !== null && as !== void 0 ? as : defaultAs,
    ref: ref,
    href: href,
    disabled: disabled
  }, mergeProps({
    onMouseEnter: onMouseEnter,
    onMouseLeave: hideHover,
    onClick: hideHover
  }, other)), /*#__PURE__*/React.createElement(Content, {
    $iconAfter: !!iconAfter
  }, iconBefore, /*#__PURE__*/React.createElement(Text, {
    color: disabled ? 'tintA40' : 'body',
    truncate: true,
    variant: "body"
  }, label), iconAfter));
});
var StyledNavItem = styled.button.withConfig({
  displayName: "NavItem__StyledNavItem",
  componentId: "vapor__bqxv24-0"
})(["", ";cursor:pointer;display:inline-flex;align-items:center;user-select:none;position:relative;height:calc(", " + ", ");padding:calc(", " - ", ") ", ";width:100%;text-decoration:none;outline:none;color:", ";&:before{content:'';position:absolute;top:", ";left:0px;right:0px;bottom:", ";border-radius:", ";opacity:0;pointer-events:none;background-color:", ";}", "{color:", ";&:before{opacity:1;}}", "{color:", ";&:before{opacity:1;box-shadow:inset 0 0 0 1px rgba(255,255,255,0.7);}}", " &[disabled]{color:", ";pointer-events:none;}"], buttonReset, theme.spaces[32], theme.spaces[4], theme.spaces[4], theme.spaces[4], theme.spaces[4], function (p) {
  return p.$isSelected ? theme.colors.palette.grey70 : theme.colors.palette.grey40;
}, theme.spaces[2], theme.spaces[2], theme.radii[4], theme.colors.palette.grey20, whenActive, theme.colors.palette.grey70, whenFocused, theme.colors.palette.grey70, function (p) {
  return p.$isSelected && "\n    &:before {\n      opacity: 1;\n    }\n  ";
}, theme.colors.palette.grey30);
var Content = styled.div.withConfig({
  displayName: "NavItem__Content",
  componentId: "vapor__bqxv24-1"
})(["position:relative;align-items:center;flex:1;display:grid;grid-template-columns:", ";grid-column-gap:", ";text-align:left;"], function (p) {
  return p.$iconAfter ? "".concat(theme.spaces[24], " 1fr ").concat(theme.spaces[24]) : "".concat(theme.spaces[24], " 1fr");
}, theme.spaces[4]);